

























































import {Component, Vue} from "vue-property-decorator";
import SearchBox from "@/components/SearchBox.vue";
import VueError from "@/components/VueError.vue";
import PageNav from "@/components/PageNav.vue";
import Loading from "@/components/Loading.vue";
import NavBar from "@/components/NavBar.vue";
import NtagTagRow from "@/components/ntag/NtagTagRow.vue";
import {DateTime} from "luxon";
import {curPref} from "@/services/Preferences";
import {NTag} from "@/types/ntag";
import {curNtagClient, NtagClient} from "@/services/NtagClient";
import * as _ from "lodash";
import moment from "moment";
import fileDownload from "js-file-download";

@Component({
  components: {
    NtagTagRow,
    SearchBox,
    VueError,
    PageNav,
    Loading,
    NavBar
  },
})
export default class NtagTags extends Vue {
  // our model
  dateTime = DateTime;
  curOrderBy = curPref.retrieve('v3-ntag-tags-cur-order', 'locationId');
  curAscDesc = curPref.retrieve('v3-ntag-tags-cur-asc-desc', 'asc');
  searchTerm = curPref.retrieve('v3-ntag-tags-search-term', '');
  pageSize = 20;
  error:string = '';
  httpBusy:boolean = false;
  tagList:NTag[] = [];

  // internal dependencies
  private ntagClient:NtagClient = curNtagClient;

  async mounted() {
    await this.refreshData();
  }

  async refreshData() {

    this.httpBusy = true;

    const reply = await this.ntagClient.getTags();

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to load ntags because ${reply.errorMsg}`;

    this.tagList = this.sortTags(reply.tags);
  }

  sortTags(tags: NTag[]): NTag[] {
    return _.orderBy(tags, [this.curOrderBy], [this.curAscDesc]);
  }

  newOrderBy(newOrderBy:{orderBy:string, ascDesc:string}) {

    curPref.store('v3-ntag-tags-cur-order', newOrderBy.orderBy);
    curPref.store('v3-ntag-tags-cur-asc-desc', newOrderBy.ascDesc);

    this.curOrderBy = newOrderBy.orderBy;
    this.curAscDesc = newOrderBy.ascDesc;

    this.refreshData();
  }

  newSearchText(newSearchText:string) {

    curPref.store('v3-ntag-tags-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  async exportTags() {
    const csvExport = this.tagsToCSV(this.tagList.concat());

    const filename = `export-ntags-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  private tagsToCSV(tags: NTag[]): string {
    const retList:string[] = [];

    retList.push(`tagId,name,enterpriseId,currentLocation,lastOnline,sku,temperature,groups`);

    for(const tag of tags) {

      const row = [];
      row.push(this.forceString(tag.id));
      row.push(this.forceString(tag.name ?  tag.name : ''));
      row.push(this.forceString(tag.enterpriseId.replace(/^nnn\./, '')));
      row.push(this.forceString(tag.location ? tag.location.name as string : ''));
      row.push(moment(tag.lastOnline).format());
      row.push(tag.sku ? tag.sku : '');
      row.push(tag.temperature ? tag.temperature : '');
      row.push(this.forceString(_.map(
          _.filter(tag.groups, groupId => !groupId.endsWith('master')),
          groupId => groupId.replace(/^nnn\./, ''))
          .join("|")));

      retList.push(row.join(','));
    }

    return retList.join("\n");
  }

  private forceString(data:string):string {
    return `"${data}"`;
  }

  get showSearchBox():boolean {
    return false;
    // return this.probeList.length > 0 || this.searchTerm !== '';
  }

  /*get showPageNav():boolean {
    return this.pageList.length > 0;
  }*/

  get showTagRows():boolean {
    return !this.httpBusy && this.tagList.length > 0;
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.tagList.length === 0 && this.searchTerm !== '';
  }

  get showNoTags():boolean {
    return !this.httpBusy && this.tagList.length === 0 && this.searchTerm === '';
  }

}
